<template>
  <div class="product">
    <img class="product-img" :src="imgPath" alt="product-img">
    <div class="info">
      <p>{{ name }}</p>
      <div class="price">
        <p>From: ${{ price }} </p>
        <p v-if="type != 3">&ThinSpace; /month</p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ProductCard',
  props: {
    imgPath: String,
    name: String,
    price: Number,
    type: Number,
  },
  mounted() {
  },
  methods: {
  },
  components: {
  }
}
</script>

<style scoped>
.info > * {
  margin: 0
}

p {
  text-align: center;
}
.product {
  width: 250px;
  height: 250px;
  background-color: transparent;
  border-radius: 1em;
  padding: 1em;
  margin: 0.7em;
  box-shadow: 1px 1px 11px 9px rgba(0, 0, 0, 0.12);
  -webkit-box-shadow: 1px 1px 11px 9px rgba(0, 0, 0, 0.12);
  -moz-box-shadow: 1px 1px 11px 9px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.product-img {
  width: 220px;
  max-height: 190px;
}
.price {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
